import { render, staticRenderFns } from "./PremiumCongratsLink.vue?vue&type=template&id=1ddea1cc&"
import script from "./PremiumCongratsLink.vue?vue&type=script&lang=js&"
export * from "./PremiumCongratsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports